import html2pdf from "html2pdf.js";
import html2canvas from "html2canvas";
import moment from "moment";
import { mapActions ,mapGetters} from "vuex";
import { faTruckMonster } from "@fortawesome/free-solid-svg-icons";
import StackedBarChart from "../../../assets/js/Charts/StackedBarChartPdf";
import BarChart from "../../../assets/js/Charts/BarChart";
import PieChart from "../../../assets/js/Charts/PieChart";
import apexchart from "../../../../node_modules/vue-apexcharts";
import { isTokenValid } from "../../../utils/util";

export default {
  name: "PDF",
  computed:{
    ...mapGetters("addholdings", {
      get_is_premium: "get_is_premium"
    })
  },
  components: {
    PieChart,
    BarChart,
    apexchart,
    StackedBarChart,
    html2canvas,
    html2pdf,
    moment,
  },
  props: [
    "imgPath",
    "transactionData",
    "reportData",
    "portfolioData",
    "rankingLastRow",
    "sectorBreakdown",
    "sectorLarge",
    "sectorMid",
    "sectorSmall",
    "recommData",
    "date",
    "pdfDate",
    "client",
    "jmUser",
    "brokerOrModelForRecomm",
    "brokerOrModelForPortfolio",
    "plotPieData",
    "plotPieDataForModel",
    "plotPieDataForTop5User",
    "plotPieDataForTop5Model",
    "plotBarData",
    "plotBarDataForModel",
    "noDataMsg",
    "chartData",
    "chartDataForTop5User",
    "chartDataForTop5Model",
    "chartDataForModel",
    "barData",
    "barOptions",
    "barDataForModel",
    "barOptionsForModel",
    "arUser",
    "bankingRow",
    "initCashPct",
    "stackedBarDataForInit",
    "stackedBarOptionsForInit",
    "stackedBarDataForFinal",
    "stackedBarOptionsForFinal",
    "quarterlyReturns",
    "is_premium",
    "TradingAnalysisScorecard",
    "TradingAnalysisComments",
    "TradingAnalysisTotalScore",
    "overallComment",
    "annualReport",
    "isBrokerUser",
    "isBrokerGuest",
    "returnDistribution",
    "isBrokerAdminUser",
    "valuationEstimates",
    "isMSIUser",
  ],

  data() {
    return {
      pScoreSeries: this.is_premium ==1 ? [this.getFixedVal(this.TradingAnalysisTotalScore.total_marks.Pct_score)] : [0],
      pEpsStrength: this.is_premium ==1 ?  [this.getFixedVal(this.TradingAnalysisScorecard['EPS Strength'].Pct)] : [0],
      pAnnualSalesGrowth: this.is_premium ==1 ?  [this.getFixedVal(this.TradingAnalysisScorecard['Sales Growth (Annual)'].Pct)] : [0],
      pAnnualRoe: this.is_premium ==1 ?  [this.getFixedVal(this.TradingAnalysisScorecard['ROE (Annual)'].Pct)] : [0],
      pNetMarginAnnual: this.is_premium ==1 ?  [this.getFixedVal(this.TradingAnalysisScorecard['Net Margin (Annual)'].Pct)] : [0],
      pAnnualDebtEquity:  this.is_premium ==1 ? [this.getFixedVal(this.TradingAnalysisScorecard['Debt/Equity (Annual)'].Pct)] : [0],
      pQuarterlySalesGrowth: this.is_premium ==1 ?  [this.getFixedVal(this.TradingAnalysisScorecard['Sales Growth (Quarterly)'].Pct)] : [0],
      pQuarterlyEPSGrowth: this.is_premium ==1 ?  [this.getFixedVal(this.TradingAnalysisScorecard['EPS Growth (Quarterly)'].Pct)] : [0],
      pLiquidityAndMarketCap: this.is_premium ==1 ?  [this.getFixedVal(this.TradingAnalysisScorecard['Net Margin (Annual)'].Pct)] : [0], //data
      pSectorBias: this.is_premium ==1 ?  [this.getFixedVal(this.TradingAnalysisScorecard['Sector Bias'].Pct)] : [0],
      pDividendBias: this.is_premium ==1 ?  [this.getFixedVal(this.TradingAnalysisScorecard['Dividend Bias'].Pct)] : [0],
      pWinLossRate:  this.is_premium ==1 ? [this.getFixedVal(this.TradingAnalysisScorecard['Win Rate (%)'].Pct)] : [0],
      pRiskReward: this.is_premium ==1 ?  [this.getFixedVal(this.TradingAnalysisScorecard['Risk Reward (X)'].Pct)] : [0],
      pHoldingdays:  this.is_premium ==1 ? [this.getFixedVal(this.TradingAnalysisScorecard['Holding days (X)'].Pct)] : [0],
      pLossAversion:  this.is_premium ==1 ? [this.getFixedVal(this.TradingAnalysisScorecard['Loss Aversion'].Pct)] : [0],
      pWinnersTurnLosers: this.is_premium ==1 ?  [this.getFixedVal(this.TradingAnalysisScorecard['Winners turn Losers'].Pct)] : [0],
      pBuyerDemand: this.is_premium ==1 ?  [this.getFixedVal(this.TradingAnalysisScorecard['Buyer Demand'].Pct)] : [0],
      pPriceStrength: this.is_premium ==1 ?  [this.getFixedVal(this.TradingAnalysisScorecard['Price Strength'].Pct)] : [0],
      pIdealBuyRange: this.is_premium ==1 ?  [this.getFixedVal(this.TradingAnalysisScorecard['Ideal Buy Range'].Pct)] : [0],
      pMovingAverages: this.is_premium ==1 ?  [this.getFixedVal(this.TradingAnalysisScorecard['Moving Averages'].Pct)] : [0],
      pDrawdown: this.is_premium ==1 ?  [this.getFixedVal(this.TradingAnalysisScorecard.Drawdown.Pct)] : [0],

      pTotalReturn: this.is_premium ==1 ?  [this.getFixedVal(this.TradingAnalysisScorecard['Total Return'].Pct)] : [0],
      pCAGRReturn: this.is_premium ==1 ?  [this.getFixedVal(this.TradingAnalysisScorecard['CAGR Return'].Pct)] : [0],
      pYTDReturn: this.is_premium ==1 ?  [this.getFixedVal(this.TradingAnalysisScorecard['YTD Return'].Pct)] : [0],
      pSharpeRatio: this.is_premium ==1 ?  [this.getFixedVal(this.TradingAnalysisScorecard['Sharpe Ratio'].Pct)] : [0],
      pSortinoRatio:  this.is_premium ==1 ? [this.getFixedVal(this.TradingAnalysisScorecard['Sortino Ratio'].Pct)] : [0],
      pCalmarRatio: this.is_premium ==1 ?  [this.getFixedVal(this.TradingAnalysisScorecard['Calmar Ratio'].Pct)] : [0],
      pOmega: this.is_premium ==1 ?  [this.getFixedVal(this.TradingAnalysisScorecard.Omega.Pct)] : [0],
      pPortfolioDrawdown: this.is_premium ==1 ?  [this.getFixedVal(this.TradingAnalysisScorecard['Portfolio Drawdown'].Pct)] : [0],
      portfolioHeader:  this.is_premium ==1 ? (this.TradingAnalysisTotalScore.total_marks.Pct_score >= 85 ? 'GREAT' : this.TradingAnalysisTotalScore.total_marks.Pct_score >= 65 ? 'GOOD' : this.TradingAnalysisTotalScore.total_marks.Pct_score >= 45 ? 'FAIR' : this.TradingAnalysisTotalScore.total_marks.Pct_score >= 20 ? 'POOR' : 'VERY POOR') : '',

      //Values
      pEpsStrengthValue: this.is_premium ==1 ?  this.getFixedVal(this.TradingAnalysisScorecard['EPS Strength'].value) : 0,
      pAnnualSalesGrowthValue:  this.is_premium ==1 ? this.getFixedVal(this.TradingAnalysisScorecard['Sales Growth (Annual)'].value): 0,
      pAnnualRoeValue: this.is_premium ==1 ?  this.getFixedVal(this.TradingAnalysisScorecard['ROE (Annual)'].value): 0,
      pNetMarginAnnualValue:  this.is_premium ==1 ?  this.getFixedVal(this.TradingAnalysisScorecard['Net Margin (Annual)'].value) : 0,
      pAnnualDebtEquityValue: this.is_premium ==1 ?  this.getFixedVal(this.TradingAnalysisScorecard['Debt/Equity (Annual)'].value): 0,
      pQuarterlySalesGrowthValue:  this.is_premium ==1 ? this.getFixedVal(this.TradingAnalysisScorecard['Sales Growth (Quarterly)'].value): 0,
      pQuarterlyEPSGrowthValue: this.is_premium ==1 ?  this.getFixedVal(this.TradingAnalysisScorecard['EPS Growth (Quarterly)'].value): 0,
      pLiquidityAndMarketCapValue: this.is_premium ==1 ?  this.getFixedVal(this.TradingAnalysisScorecard['Net Margin (Annual)'].value): 0, //data
      pSectorBiasValue:  this.is_premium ==1 ? this.getFixedVal(this.TradingAnalysisScorecard['Sector Bias'].value): 0,
      pDividendBiasValue: this.is_premium ==1 ? this.getFixedVal(this.TradingAnalysisScorecard['Dividend Bias'].value): 0,
      pWinLossRateValue:  this.is_premium ==1 ? this.getFixedVal(this.TradingAnalysisScorecard['Win Rate (%)'].value): 0,
      pRiskRewardValue:  this.is_premium ==1 ? this.getFixedVal(this.TradingAnalysisScorecard['Risk Reward (X)'].value): 0,
      pHoldingdaysValue: this.is_premium ==1 ?  this.getFixedVal(this.TradingAnalysisScorecard['Holding days (X)'].value): 0,
      pLossAversionValue:  this.is_premium ==1 ? this.getFixedVal(this.TradingAnalysisScorecard['Loss Aversion'].value): 0,
      pWinnersTurnLosersValue:  this.is_premium ==1 ? this.getFixedVal(this.TradingAnalysisScorecard['Winners turn Losers'].value): 0,
      pBuyerDemandValue:  this.is_premium ==1 ? this.getFixedVal(this.TradingAnalysisScorecard['Buyer Demand'].value): 0,
      pPriceStrengthValue:  this.is_premium ==1 ? this.getFixedVal(this.TradingAnalysisScorecard['Price Strength'].value): 0,
      pIdealBuyRangeValue: this.is_premium ==1 ?  this.getFixedVal(this.TradingAnalysisScorecard['Ideal Buy Range'].value): 0,
      pMovingAveragesValue:  this.is_premium ==1 ? this.getFixedVal(this.TradingAnalysisScorecard['Moving Averages'].value): 0,
      pDrawdownValue: this.is_premium ==1 ?  this.getFixedVal(this.TradingAnalysisScorecard.Drawdown.value): 0,

      pTotalReturnValue:  this.is_premium ==1 ? this.getFixedVal(this.TradingAnalysisScorecard['Total Return'].value): 0,
      pCAGRReturnValue:  this.is_premium ==1 ? this.getFixedVal(this.TradingAnalysisScorecard['CAGR Return'].value): 0,
      pYTDReturnValue:  this.is_premium ==1 ? this.getFixedVal(this.TradingAnalysisScorecard['YTD Return'].value): 0,
      pSharpeRatioValue:  this.is_premium ==1 ? this.getFixedVal(this.TradingAnalysisScorecard['Sharpe Ratio'].value): 0,
      pSortinoRatioValue: this.is_premium ==1 ?  this.getFixedVal(this.TradingAnalysisScorecard['Sortino Ratio'].value): 0,
      pCalmarRatioValue:  this.is_premium ==1 ? this.getFixedVal(this.TradingAnalysisScorecard['Calmar Ratio'].value): 0,
      pOmegaValue: this.is_premium ==1 ?  this.getFixedVal(this.TradingAnalysisScorecard.Omega.value): 0,
      pPortfolioDrawdownValue: this.is_premium ==1 ?  this.getFixedVal(this.TradingAnalysisScorecard['Portfolio Drawdown'].value): 0,


      tradeChartOptions: {
        chart: {
          type: "radialBar",
          offsetY: -20,
          offsetX: 250,
          sparkline: {
            enabled: true,
          },
          height: "400px",
        },
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            track: {
              background: "#1f58a0",
              strokeWidth: "100%",
              margin: 5, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: 2,
                left: 0,
                color: "#999",
                opacity: 1,
                blur: 2,
              },
            },
            dataLabels: {
              show: false,
              name: {
                show: false,
              },
              value: {
                show: false,
                fontSize: "24px",
                fontFamily: undefined,
                fontWeight: 400,
                color: "#104c99",
                offsetY: -15,
                formatter: function (val) {
                  return val;
                },
              },
            },
            hollow: {
              margin: 10,
              size: "36%",
              background: "#fff",
              image: undefined,
              imageWidth: 150,
              imageHeight: 150,
              imageOffsetX: 0,
              imageOffsetY: 0,
              imageClipped: true,
              position: "front",
              dropShadow: {
                enabled: false,
                top: 0,
                left: 0,
                blur: 3,
                opacity: 0.5,
              },
            },
          },
        },
        grid: {
          padding: {
            top: -10,
          },
        },
        fill: {
          opacity: 1.5,
          colors: ["#acb8c9"],
          type: "gradient",
          gradient: {
            gradientToColors: ["#acb8c9"],
            shadeIntensity: 1,
            opacityFrom: 1,
            opacityTo: 2,
            stops: [0, 50, 100],
            inverseColors: false,
          },
          stroke: {
            lineCap: "round",
          },
        },
        labels: ["Average Results"],
      },
      portfolioScoreChartOptions: {
        chart: {
          type: "radialBar",
          offsetY: -20,
          offsetX: 250,
          sparkline: {
            enabled: true,
          },
          height: "400px",
        },
        colors: ["#ecf018"],
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            track: {
              background: "#000000",
              strokeWidth: "100%",
              margin: 5, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: 2,
                left: 0,
                color: "#999",
                opacity: 1,
                blur: 2,
              },
            },
            dataLabels: {
              show: true,
              name: {
                show: false,
              },
              value: {
                show: true,
                fontSize: "24px",
                fontFamily: undefined,
                fontWeight: 600,
                color: "#FFFFFF",
                offsetY: -15,
                formatter: function (val) {
                  return val;
                },
              },
            },
            hollow: {
              margin: 50,
              size: "38%",
              background: "#000000",
              image: undefined,
              imageWidth: 150,
              imageHeight: 150,
              imageOffsetX: 0,
              imageOffsetY: 0,
              imageClipped: true,
              position: "front",
              dropShadow: {
                enabled: false,
                top: 0,
                left: 0,
                blur: 3,
                opacity: 0.5,
              },
            },
          },
        },
        grid: {
          padding: {
            top: -10,
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: ['#f06616'],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100]
          }
        },
          stroke: {
            lineCap: "butt",
          },
        labels: ["Average Results"],
      },
      stockDivSeries: [
        {
          name: "Small",
          data: [
            {
              x: "Value",
              y: this.getTwoFixedValWithZero(this.sectorSmall.Value),
            },
            {
              x: "Core",
              y: this.getTwoFixedValWithZero(this.sectorSmall.Core),
            },
            {
              x: "Growth",
              y: this.getTwoFixedValWithZero(this.sectorSmall.Growth),
            },
            {
              x: "Not graded",
              y: this.getTwoFixedValWithZero(this.sectorSmall.Undergraded),
            },
          ],
        },
        {
          name: "Mid",
          data: [
            {
              x: "Value",
              y: this.getTwoFixedValWithZero(this.sectorMid.Value),
            },
            {
              x: "Core",
              y: this.getTwoFixedValWithZero(this.sectorMid.Core),
            },
            {
              x: "Growth",
              y: this.getTwoFixedValWithZero(this.sectorMid.Growth),
            },
            {
              x: "Not graded",
              y: this.getTwoFixedValWithZero(this.sectorMid.Undergraded),
            },
          ],
        },
        {
          name: "Large",
          data: [
            {
              x: "Value",
              y: this.getTwoFixedValWithZero(this.sectorLarge.Value),
            },
            {
              x: "Core",
              y: this.getTwoFixedValWithZero(this.sectorLarge.Core),
            },
            {
              x: "Growth",
              y: this.getTwoFixedValWithZero(this.sectorLarge.Growth),
            },
            {
              x: "Not graded",
              y: this.getTwoFixedValWithZero(this.sectorLarge.Undergraded),
            },
          ],
        },
      ],
      stockDivChartOptions: {
        chart: {
          height: 400,
          type: 'heatmap',
          toolbar: {
            show: false,
            tools: {
              download: false,
            },
          },
        },
        dataLabels: {
          enabled: false,
          style: {
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: '400',
            colors: ['#2E294E'],
          },
          formatter(val, opts) {
            return `${Math.abs(val)}%`;
          },
        },
        colors: ["#468fec"],
        grid: {
          position: 'front',
          xaxis: {
            lines: {
              show: true,
            },
          },
          yaxis: {
            lines: {
              show: true,
            },
          },
        },
        labels: {
          formatter(val, index) {
            return val.toFixed(2);
          },
        },
        xaxis: {
          axisTicks: {
            show: false,
          },
          type: 'category',
          categories: [],
          labels: {
            style: {
              colors: '#737373',
              fontSize: '12px',
              fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial'",
              fontWeight: '400',
            },
          },
        },
        yaxis: {
          tickAmount: 6,
          labels: {
            style: {
              colors: '#737373',
              fontSize: '13px',
              fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial'",
              fontWeight: '400',
            },
          },
        },
        tooltip: {
          shared: false,
          x: {
            formatter(val) {
              return val;
            },
          },
          y: {
            formatter(val) {
              return `${Math.abs(val)}%`;
            },
          },
        },
      },

      sectorSeries: [
        {
          name: "Nifty 50",
          data: this.getSectorNiftyData(this.sectorBreakdown),
        },
        {
          name: "Portfolio",
          data: this.getSectorPortfolioData(this.sectorBreakdown),
        },
      ],
      sectorChartOptions: {
        chart: {
          type: 'bar',
          width: 1200,
          height: 800,
          toolbar: {
            show: false
          },
        },
        colors: ['#468fec', '#104c99'],
        grid: {
          // position: 'front',
          // xaxis: {
          //   lines: {
          //     show: true,
          //   },
          // },
          // yaxis: {
          //   lines: {
          //     show: true,
          //   },
          // },
        },
        plotOptions: {
          bar: {
            // barHeight: '80%',
            horizontal: false,
            columnWidth: '45%',
            endingShape: 'rounded'
          },
        },
        dataLabels: {
          enabled: false,
          // textAnchor: 'middle',
          // position: 'top',
          // formatter(val, opts) {
          //   return `${Math.abs(val)}%`;
          // },
          // offsetX: 40,
          // style: {
          //   fontSize: '12px',
          //   fontFamily: 'Helvetica, Arial, sans-serif',
          //   fontWeight: '400',
          //   colors: ['#2E294E'],
          // },
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
          // width: 1,
          // colors: ['#fff'],
        },
        legend: {
          show: false
        },
        yaxis: {
          min: 0,
          max: 100,
          labels: {
            formatter: function(value) {
              return value.toFixed(0) + "%";
            }
          },
        },
        // yaxis: {
        //   axisBorder: {
        //     show: false,
        //   },
        //   min: -100,
        //   max: 100,
        //   title: {
        //     text: '',
        //   },
        //   labels: {
        //     maxWidth: 250,
        //     style: {
        //       colors: '#737373',
        //       fontSize: '12px',
        //       fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial'",
        //       fontWeight: '500',
        //     },
        //   },
        // },
        fill: {
          opacity: 1
        },
        tooltip: {
          // shared: false,
          // x: {
          //   formatter(val) {
          //     return val;
          //   },
          // },
          y: {
            formatter(val) {
              return `${Math.abs(val)}%`;
            },
          },
        },
        xaxis: {
          // axisBorder: {
          //   show: false,
          // },
          // axisTicks: {
          //   show: false,
          // },
          categories: this.getSectorXaxis(this.sectorBreakdown),
          // title: {
          //   text: '',
          // },
          labels: {
            rotate: -90,
            // style: {
            //   colors: '#737373',
            //   fontSize: '5px',
            //   fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial'",
            //   fontWeight: '500',
            // },
            // formatter(val) {
            //   return `${Math.abs(Math.round(val))}%`;
            // },
          },
        },
      },
      annualSeries: [{
        name: 'Annual Returns',
        data: this.getAnnualReturns(this.annualReport),
      }, {
        name: 'Annual Benchmark Returns',
        data: this.getAnnualBenchmarkReturns(this.annualReport),
      }],
      annualChartOptions: {
        chart: {
          type: 'bar',
          height: 350,
          toolbar: {
            show: false,
            tools: {
              download: false,
              selection: false,
              reset: false,
            },
          },
        },
        legend: {
          show: false,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '75%',
            endingShape: 'flat',
          },
        },
        colors: ['#006cd7', '#adcef9'],
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '16px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: '400',
            colors: ['#2E294E'],
          },
          formatter(val, opts) {
            return `${val}%`;
          },
        },
        stroke: {
          show: true,
          width: 1,
          colors: ['transparent'],
        },
        xaxis: {
          categories: this.getAnnualYears(this.annualReport),
          labels: {
            style: {
              colors: '#666',
              fontSize: '13px',
              fontFamily: "Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
              fontWeight: 500,
            },
            formatter(val) {
              return `${val}`;
            },
          },
        },
        yaxis: {
          title: {
            text: '',
          },
          labels: {
            style: {
              colors: '#666',
              fontSize: '13px',
              fontFamily: "Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
              fontWeight: 500,
            },
            formatter(val) {
              return `${val}%`;
            },
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter(val) {
              return ` ${val} `;
            },
          },
        },
      },
      quarterlyChartSeries: this.getQuarterlyData(),
      quarterlyChartOptions: {
        chart: {
          height: 350,
          type: 'heatmap',
          toolbar: {
            show: false,
            tools: {
              download: false,
              selection: false,
              reset: false,
            },
          },
        },
        legend: {
          show: false,
          position: 'bottom',
          horizontalAlign: 'center',
          //offsetX: 110,
        },
        stroke: {
          show: true,
          width: 1,
        },
        plotOptions: {
          heatmap: {
            shadeIntensity: 0.5,
            radius: 0,
            useFillColorAsStroke: true,
            colorScale: {
              ranges: [{
                from: -100.00,
                to: -1.00,
                name: '(<0%)',
                color: '#f1f6fe'//'#FEB019',
              },
              {
                from: -0.99,
                to: 10.00,
                name: '(0-10%)',
                color: '#468fec'//'#F9CE1D',
              },
              {
                from: 10.01,
                to: 20.00,
                name: '(10-20%)',
                color: '#00FF00'//'#00E396',
              },
              {
                from: 20.01,
                to: 100.00,
                name: '(>20%)',
                color: '#006400'//'#4CAF50',
              },
              ],
            },
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '16px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: '400',
            colors: ['#2E294E'],
          },
          formatter(val, opts) {
            return `${val}%`;
          },
        },
        colors: ['#A300D6'],
        // grid: {
        //   position: 'front',
        //   xaxis: {
        //     lines: {
        //       show: true,
        //     },
        //   },
        //   yaxis: {
        //     lines: {
        //       show: true,
        //     },
        //   },
        // },
        labels: {
          formatter(val, index) {
            return val.toFixed(2);
          },
        },
        xaxis: {
          type: 'category',
          categories: [],
          labels: {

            style: {
              colors: '#666',
              fontSize: '13px',
              fontFamily: "Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
              fontWeight: 500,
            },
          },
        },
        yaxis: {
          tickAmount: 6,
          labels: {

            style: {
              colors: '#666',
              fontSize: '13px',
              fontFamily: "Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
              fontWeight: 500,
            },
          },
        },
        tooltip: {
          shared: false,
          x: {
            formatter(val) {
              return val;
            },
          },
          y: {
            formatter(val) {
              return `${Math.abs(val)}%`;
            },
          },
        },
      },
      returnDistributionSeries: [{
        name: 'Transactions Count',
        data:this.getReturnDistributionYaxis(this.returnDistribution)
      }],
      returnDistributionChartOptions: {
        chart: {
          height: 350,
          type: 'bar',
          toolbar: {
            show: false,
            tools: {
              download: false,
              selection: false,
              reset: false,
            },
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            dataLabels: {
              position: 'top', // top, center, bottom
            },
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val;
          },
          offsetY: -20,
          style: {
            fontSize: '16px',
            colors: ["#304758"]
          }
        },

        xaxis: {
          categories: this.getReturnDistributionXaxis(this.returnDistribution),
          position: 'bottom',
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          title: {
            text: 'Returns %',
          },
          labels: {
            show: true,
            formatter: function (val) {
              return val + " %";
            }
          },
          crosshairs: {
            fill: {
              type: 'gradient',
              gradient: {
                colorFrom: '#D8E3F0',
                colorTo: '#BED1E6',
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5,
              }
            }
          },
          tooltip: {
            enabled: true,
          }
        },
        yaxis: {
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false,
          },
          title: {
            text: 'Transactions Count',
          },
          labels: {
            show: true,
            formatter: function (val) {
              return val + "";
            }
          }

        },
        title: {
          text: '',
          floating: true,
          offsetY: 330,
          align: 'center',
          style: {
            color: '#444'
          }
        }
      },
      holdingsSeries: [{
        data: this.barData.datasets[0].data.map(function(item) {
          return parseFloat(item);
        }).filter(cv => cv != "0")
      }],
      holdingsChartOptions: {
        chart: {
          type: 'bar',
          height: 350,
          toolbar: {
            show: false,
            tools: {
              download: false,
            },
          },
        },
        legend: {
          show: false,
        },
        plotOptions: {
          bar: {
            borderRadius: 0,
            horizontal: true,
            distributed: true
          }
        },
        dataLabels: {
          enabled: faTruckMonster,
          style: {
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: '600',
            colors: ['#ffffff'],
          },
        },
        xaxis: {
          categories: this.barData.labels,
          labels: {
            style: {
              colors: [],
              fontSize: '12px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 600,
              cssClass: 'apexcharts-xaxis-label',
            },
          }
        },
        yaxis: {
          labels: {
            style: {
              colors: [],
              fontSize: '13px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 600,
              cssClass: 'apexcharts-xaxis-label',
            },
          }
        },
      },
      breakdownByMarketcapSeries: this.chartData.datasets[0].data.map(function(item) {
        return parseFloat(item);
      }),

      breakdownByMarketcapChartOptions: {
        colors: ['#104c99', '#468fec', '#adcef9'],
        labels:["Large", "Medium", "Small"],
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return opts.w.globals.series[opts.seriesIndex];
          }
        },
        legend: {
          position: 'top',
          fontSize: '20px',
          itemMargin: {
            horizontal:0 , vertical: 10
          },
          formatter: function(seriesName, opts) {
            let val = opts.w.globals.series[opts.seriesIndex]
            return ["<span style='display: flex; justify-content: space-between; width: 100px'>"+ seriesName,  (val ? ' <span class="legendVal"><strong>'+  (val + "%") :  '<span class="legendVal"><strong>'+val + '</span></strong>'+ "</span>")]
          }
        },
        plotOptions: {
          pie: {
            startAngle: 90,
            endAngle: -270,
            expandOnClick: false,
            donut: {
              labels: {
                show: false,
                value: {
                  show: true,
                  fontSize: '16px',
                  fontFamily: 'Helvetica, Arial, sans-serif',
                  color: undefined,
                  offsetY: 16,
                  formatter: function (val) {
                    return val
                  }
                },
                total: {
                  show: true,
                  label: 'Total',
                  color: '#373d3f',
                }
              }
            }
          }
        }
      },
      eBreakdownByMarketcapSeries: this.chartData.datasets[0].data.map(function(item) {
        return parseFloat(item);
      }),
      eBreakdownByMarketcapChartOptions: {
        chart: {
          type: 'donut',
          width:600,
          height:100
        },
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return opts.w.globals.series[opts.seriesIndex];
          }
        },
        legend: {
          position: 'top',
          fontSize: '18px',
          itemMargin: {
            horizontal:0 , vertical: 10
          },
          formatter: function(seriesName, opts) {
            let val = opts.w.globals.series[opts.seriesIndex]
            return ["<span >"+ seriesName,  (val ? ' <span class="legendVal"><strong>'+  (val + "%") :  '<span class="legendVal" style="padding-left:10px"><strong >'+val + '</span></strong>'+ "</span>")]
          }
        },
        plotOptions: {
          pie: {

            donut: {
              labels: {
                show: false,
                value: {
                  show: true,
                  fontSize: '16px',
                  fontFamily: 'Helvetica, Arial, sans-serif',
                  color: undefined,
                  offsetY: 16,
                  formatter: function (val) {
                    return val
                  }
                },
                total: {
                  show: true,
                  label: 'Total',
                  color: '#373d3f',
                }
              }
            }
          }
        },
         colors: ['#104c99', '#468fec', '#adcef9'],
        labels:["Large", "Mid", "Small"],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
  },
      rBreakdownByMarketcapSeries: this.chartDataForModel.datasets[0].data.map(function(item) {
        return parseFloat(item);
      }),
      rBreakdownByMarketcapChartOptions: {
        chart: {
          width: 380,
          type: 'donut',
        },
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return opts.w.globals.series[opts.seriesIndex];
          }
        },
        legend: {
          position: 'top',
          fontSize: '16px',
          itemMargin: {
            horizontal:0 , vertical: 10
          },
          formatter: function(seriesName, opts) {
            let val = opts.w.globals.series[opts.seriesIndex]
            return ["<span >"+ seriesName,  (val ? ' <span class="legendVal"><strong>'+  (val + "%") :  '<span class="legendVal" style="padding-left:10px"><strong >'+val + '</span></strong>'+ "</span>")]
          }
        },
        plotOptions: {
          pie: {

            donut: {
              labels: {
                show: false,
                value: {
                  show: true,
                  fontSize: '16px',
                  fontFamily: 'Helvetica, Arial, sans-serif',
                  color: undefined,
                  offsetY: 16,
                  formatter: function (val) {
                    return val
                  }
                },
                total: {
                  show: true,
                  label: 'Total',
                  color: '#373d3f',
                }
              }
            }
          }
        },
        colors: ['#104c99', '#468fec', '#adcef9'],
        labels:["Large", "Mid", "Small"],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
  },
      eHoldingsSeries: [{
        data: this.barData.datasets[0].data.map(function(item) {
          return parseFloat(item);
        }).filter(cv => cv != "0")
      }],
      eHoldingsChartOptions: {
        chart: {
          type: 'bar',
          height: 50,
          toolbar: {
            show: false,
            tools: {
              download: false,
            },
          },
        },
        legend: {
          show: false,
        },
        plotOptions: {
          bar: {
            borderRadius: 0,
            horizontal: true,
            distributed: true
          }
        },

        dataLabels: {
          enabled: faTruckMonster,
          style: {
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: '600',
            colors: ['#ffffff'],
          },
        },
        xaxis: {
          categories: this.barData.labels,
          labels: {
            style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 600,
                cssClass: 'apexcharts-xaxis-label',
            },
          }
        },
        yaxis: {
          labels: {
            style: {
                colors: [],
                fontSize: '13px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 600,
                cssClass: 'apexcharts-xaxis-label',
            },
          }
        }
      },
      rHoldingsSeries: [{
        data: this.barDataForModel.datasets[0].data.map(function(item) {
          return parseFloat(item);
        }).filter(cv => cv != "0")
      }],
      rHoldingsChartOptions: {
        chart: {
          type: 'bar',
          height: 50,
          toolbar: {
            show: false,
            tools: {
              download: false,
            },
          },
        },
        legend: {
          show: false,
        },
        plotOptions: {
          bar: {
            borderRadius: 0,
            horizontal: true,
            distributed: true
          }
        },
        dataLabels: {
          enabled: faTruckMonster,
          style: {
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: '600',
            colors: ['#ffffff'],
          },
        },
        xaxis: {
          categories: this.barDataForModel.labels,
          labels: {
            style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 600,
                cssClass: 'apexcharts-xaxis-label',
            },
          }
        },
        yaxis: {
          labels: {
            style: {
                colors: [],
                fontSize: '13px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 600,
                cssClass: 'apexcharts-xaxis-label',
            },
          }
        }
      },
      //Top 5 allocation
      eAllocationSeries: this.chartDataForTop5User.datasets[0].data.map(function(item) {
        return parseFloat(item);
      }),
      eAllocationChartOptions: {
        chart: {
          width: 480,
        },
        legend: {
          position: 'top',
          fontSize: '14px',
          itemMargin: {
            horizontal: 0, vertical: 10
          },
          formatter: function(seriesName, opts) {
            let val = opts.w.globals.series[opts.seriesIndex]
            return ["<span >"+ seriesName,  (val ? ' <span class="legendVal"><strong>'+  (val + "%") :  '<span class="legendVal" style="padding-left:10px"><strong >'+val + '</span></strong>'+ "</span>")]
          }
        },

        plotOptions: {
          pie: {
            startAngle: 90,
            endAngle: -270,
            donut: {
              labels: {
                show: false,
                value: {
                  show: true,
                  fontSize: '16px',
                  fontFamily: 'Helvetica, Arial, sans-serif',
                  color: undefined,
                  offsetY: 16,
                  formatter: function (val) {
                    return val
                  }
                },
                total: {
                  show: true,
                  label: 'Total',
                  color: '#373d3f',
                }
              }
            }
          }
        },

        labels:this.chartDataForTop5User.labels,
        colors: ['#104c99', '#00e396', '#feb019', '#ff4560', '#775dd0'],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },

          }
        }]
  },
      rAllocationSeries: this.chartDataForTop5Model.datasets[0].data.map(function(item) {
        return parseFloat(item);
      }),
      rAllocationChartOptions: {
        chart: {
          width: 480,
        },
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return opts.w.globals.series[opts.seriesIndex];
          }
        },
        legend: {
          position: 'top',
          fontSize: '14px',
          formatter: function(seriesName, opts) {
            let val = opts.w.globals.series[opts.seriesIndex]
            return ["<span >"+ seriesName,  (val ? ' <span class="legendVal"><strong>'+  (val + "%") :  '<span class="legendVal"><strong>'+val + '</span></strong>'+ "</span><br>")]
          },
          itemMargin: {
            horizontal: 0, vertical: 10
          },

        },

        plotOptions: {
          pie: {
            startAngle: 90,
            endAngle: -270,
            donut: {
              labels: {
                show: false,
                value: {
                  show: true,
                  fontSize: '16px',
                  fontFamily: 'Helvetica, Arial, sans-serif',
                  color: undefined,
                  offsetY: 16,
                  formatter: function (val) {
                    return val
                  }
                },
                total: {
                  show: true,
                  label: 'Total',
                  color: '#373d3f',
                }
              }
            }
          }
        },

        labels:this.chartDataForTop5Model.labels,
        colors: ['#104c99', '#00e396', '#feb019', '#ff4560', '#775dd0'],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },

          }
        }]
  },
      eCashSeries: [{
        name: 'Cash',
        data: [this.stackedBarDataForInit.datasets[0].data[0]]
      }, {
        name: 'Equity',
        data:  [this.stackedBarDataForInit.datasets[1].data[0]]
      }],
      eCashChartOptions: {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          stackType: '100%',
          toolbar: {
            show: false,
            tools: {
              download: false,
            },
          },
        },
        legend: {
          show: true,
          position: 'bottom',
          horizontalAlign: 'center',
          labels: {
            color: undefined,
            useSeriesColors: true
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        colors: ['#104c99', '#468fec'],
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        title: {
          text: ''
        },
        xaxis: {
          categories: ["Cash vs Equity"],
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + "%"
            }
          }
        },
        fill: {
          opacity: 1

        }
      },
      rCashSeries: [{
        name: 'Cash',
        data: [this.stackedBarDataForFinal.datasets[0].data[0]]
      }, {
        name: 'Equity',
        data:  [this.stackedBarDataForFinal.datasets[1].data[0]]
      }],
      rCashChartOptions: {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          stackType: '100%',
          toolbar: {
            show: false,
            tools: {
              download: false,
            },
          },
        },
        legend: {
          show: true,
          position: 'bottom',
          horizontalAlign: 'center',
          labels: {
            color: undefined,
            useSeriesColors: true
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        colors: ['#104c99', '#468fec'],
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        title: {
          text: ''
        },
        xaxis: {
          categories: ["Cash vs Equity"],
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + "%"
            }
          }
        },
        fill: {
          opacity: 1

        },
      }
    };
  },

  mounted() {
    this.generatePdf();
  },
  methods: {
    ...mapActions("portfolioreport", {
      setTab: "setTab"
    }),
    ...mapActions("addholdings", {
      downloadPdfFile: "DOWNLOAD_PDF",
      postPdfDownloadSuccess: "POST_PDF_DOWNLOAD_SUCCESS",
      updatePostPdfDownloadSuccess: "UPDATE_POST_PDF_DOWNLOAD_SUCCESS",
      sendReportOverMail: "SEND_REPORT_OVER_MAIL",
      updateMSIreportSubscription: "UPDATE_MSI_REPORT_SUBSCRIPTION"
    }),

    getFilename(formdate) {
      return `PORTFOLIO_REPORT_${Math.random() * 100}.html`;
    },

    makeTextFile(text) {
      const textFile = new Blob([text], { type: "text/html;charset=utf-8;" });
      const userName = localStorage.getItem("user");
      const isBrokerManualImport = this.isBrokerAdminDidManualImport();
      if (!isBrokerManualImport) {
        textFile.name = this.isBrokerAdminUser==true? localStorage.getItem("arClientCode")+"_"+this.getFilename(userName):this.getFilename(userName);
      }
      else {
        textFile.name = 'GUEST_'+this.getFilename(userName)
      }
      textFile.lastModified = Date.now();
      return textFile;
    },

    generatePdf() {
      /* if (!isTokenValid()) {
        this.logout(this.sessionIdleErrorMsg);
        return;
      } */
      const temp = this;
      this.loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      if(this.isBrokerUser==false)
      {
      this.$toastr.Add({
        name: "info", // this is give you ability to use removeByName method
        msg:"PDF report will download soon",
        type: "success", // Toast type,
        position: "toast-top-full-width",
        clickClose: true, // Click Close Disable
        timeout: 5000,
        showCloseButton:true,
     });
      }
      // temp.downloadPdf();
      setTimeout(() => {
        temp.downloadPdf();
      }, 5000);
    },

    async dowloadFile(streamData, fileName) {
      const reportObj={
			"reportUrl": "https://storage.googleapis.com/psi-evaluation-archive/"+fileName,
			"fileName": fileName,
			"isPremium": this.get_is_premium===1?"1":"0",
			"inputData": localStorage.getItem("HoldingsData")==null?'[{\"Data\":\"input data not found\"}]': localStorage.getItem("HoldingsData").length>20000?'[{\"Data\":\"Size exceeded\"}]':localStorage.getItem("HoldingsData"),
			"outputData":localStorage.getItem("PsiReportJson")==null?'[{\"Data\":\"output data not found\"}]': localStorage.getItem("PsiReportJson").length>20000?'[{\"Data\":\"Size exceeded\"}]': localStorage.getItem("PsiReportJson"),
			"comments": ""
		}
    if (this.isBrokerGuest) {
      reportObj.clientCode = "ARGuest";
      reportObj.userId = localStorage.getItem('uid');
    }else if (this.isBrokerUser==true && !this.isBrokerGuest) {
      reportObj.clientCode= this.isBrokerAdminUser==true? localStorage.getItem("arClientCode"):localStorage.getItem('utmParams').split('utm_source=AnandRathi&utm_client_code=')[1];
      reportObj.userId = "";
    }

    if(this.isBrokerUser==true)
    {
      await this.sendReportOverMail(reportObj)
      .then(response => {
        if(response.data.response.success)
        {
          this.$toastr.Add({
            name: "info", // this is give you ability to use removeByName method
            msg:"Generated PDF report is mailed to your subscribed email id",
            type: "success", // Toast type,
            position: "toast-top-full-width",
            clickClose: true, // Click Close Disable
            timeout: 10000,
            showCloseButton:true,
         });
        }
      });
    }
    else
    {
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // for IE
        window.navigator.msSaveOrOpenBlob(streamData, fileName);
      } else {
        const a = document.createElement("a");
        const url = window.URL.createObjectURL(streamData);
        a.href = url;
        a.download = fileName;
        document.body.append(a);
        a.click();
        if (this.isMSIUser && localStorage.getItem('isPremium') == '1') {
          let params = {
            memberId:localStorage.getItem('memberId'),
            fileName: fileName
          }
          await this.updateMSIreportSubscription(params)
        }
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
          a.remove();
        }, 300);
      }
    }
    if (!this.isMSIUser) {
      if (localStorage.getItem("reEvaluatePortfolioData") != null || localStorage.getItem("reEvaluatePortfolioData") != undefined) {
        await this.updatePostPdfDownloadSuccess(reportObj)
        .then(response => {

        })
      }
      else {
        await this.postPdfDownloadSuccess(reportObj)
        .then(response => {

        });
      }
    }
      localStorage.removeItem("reEvaluatePortfolioData")
      localStorage.removeItem("preLoginHoldingsData");
      localStorage.removeItem("PsiReportJson");
    },

    async downloadPdf() {
      const temp = this;
      const element = temp.$refs.printcontent;
      const pieChartCanvas = element.querySelectorAll("[id='pie-chart']");
      const image = new Image();
      let imageContent = "";
      for (var i = 0; i < pieChartCanvas.length; i++) {
        image.src = pieChartCanvas[i].toDataURL("image/png");
        image.width = 600;
        image.height = 300;
        imageContent = `<div> ${image.outerHTML} </div>`;
        pieChartCanvas[i].parentElement.innerHTML = imageContent;
      }

      const barChartCanvas = element.querySelectorAll(
        "[id='horizontalbar-chart']"
      );
      for (var i = 0; i < barChartCanvas.length; i++) {
        image.src = barChartCanvas[i].toDataURL("image/png");
        image.width = 466;
        image.height = 300;
        imageContent = `<div> ${image.outerHTML} </div>`;
        barChartCanvas[i].parentElement.innerHTML = imageContent;
      }
      const htmlFile = this.makeTextFile(`<body> ${element.outerHTML} </body>`);
      const formData = new FormData();

      formData.append("file", htmlFile, htmlFile.name);
      formData.append("user", this.arUser);
      this.loader.hide();
      this.is_premium==1 && this.isBrokerUser==false? this.setTab("TradingAnalysis"):this.setTab("Portfolio");
      await this.downloadPdfFile(formData)
      .then((response) => {
          if (response.data) {
            this.dowloadFile(
              response.data,
              htmlFile.name.replace(".html", ".pdf")
            );
          } else {
            this.$toastr.e("Upload failed. Please try again.");
          }
        })
        .catch((e) => {
          this.$toastr.e(
            "An unknown error occured.Please try again, or contact a developer for assistance."
          );
          this.loader.hide();
          this.is_premium==1 && this.isBrokerUser==false? this.setTab("TradingAnalysis"):this.setTab("Portfolio");
        });
    },

    getUCfirst(arrays) {
      const list = [];
      arrays.map((value) => {
        const firstLetter = value.substr(0, 1);
        list.push(firstLetter.toUpperCase() + value.substr(1).toLowerCase());
      });
      return list;
    },

    getUCfirstName(name) {
      return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
    },

    getTwoFixedVal(value) {
      if (
        isNaN(value) ||
        value == 0 ||
        value == "-" ||
        value == null ||
        value == "" ||
        value ==-100000000000000
      ) {
        return "-";
      }
      return parseFloat(value).toFixed(2);
    },

    getTwoFixedValWithZero(value) {
      if (isNaN(value) || value == "-" || value == null || value == "") {
        value = 0;
      }
      return parseFloat(value).toFixed(2);
    },

    getTwoFixedValElseZero(value) {
      if (
        isNaN(value)
        || value == 0
        || value == '-'
        || value == null
        || value == ''
      ) {
        return 0;
      }
      return parseFloat(value).toFixed(2);
    },

    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },

    getIntFormat(value) {
      if (
        isNaN(value) ||
        value == 0 ||
        value == "-" ||
        value == null ||
        value == ""
      ) {
        return "-";
      }
      return this.formatNumber(parseFloat(value).toFixed(2));
    },

    onCancel() {
      this.$toastr.e("User cancelled the loader....");
    },
    getSectorXaxis(graphData) {
      const xAxisArray = [];
      for (let index = 0; index < 20; index++) {
        if (graphData[index] !== undefined)
          xAxisArray.push(graphData[index].SectorName);
      }
      return xAxisArray;
    },
    getSectorNiftyData(graphData) {
      const data = [];
      for (let index = 0; index < 20; index++) {
        if (graphData[index] !== undefined) {
          data.push(
            `${this.getTwoFixedValWithZero(graphData[index].pct_nifty50)}`
          );
        }
      }
      return data;
    },
    getSectorPortfolioData(graphData) {
      const data = [];
      for (let index = 0; index < 20; index++) {
        if (graphData[index] !== undefined) {
          data.push(
            this.getTwoFixedValWithZero(graphData[index].pct_userPortfolio)
          );
        }
      }
      return data;
    },
    getTextColor(column, value) {
      let colorclass;
      if (column === 'MasterScore' || column === 'AD_Rating') {
        if (value.includes('D') || value.includes('E')) colorclass = 'color:red';
        else if (value.includes('C')) colorclass = 'color:orange';
        else if (value.includes('A') || value.includes('B')) colorclass = 'color:green';
        else colorclass = '';
      } else if (column === 'CanslimScore' || column === 'EPS_Rank' || column === 'RS_Rank') {
        if (value >= 80) colorclass = 'color:green';
        else if (value < 80 && value >= 60) colorclass = 'color:orange';
        else if (value < 60) colorclass = 'color:red';
        else colorclass = '';
      } else if (column === 'Group_Rank') {
        if (value > 80) colorclass = 'color:red';
        else if (value <= 80 && value >= 41) colorclass = 'color:orange';
        else if (value < 40 && value >= 1) colorclass = 'color:green';
        else colorclass = '';
      }
      return colorclass;
    },
    calculateScorePct(value) {
      return `width: ${value}%`;
    },
    getFixedVal(value) {
      if (
        value === null ||
        value === "" || parseFloat(value) >= 9999 || parseFloat(value) <= -9999
      ) {
        return "NA";
      }
      else if(isNaN(value)){
        return value
      }
      else {
        return parseFloat(value).toFixed(1);
      }
    },
    getAnnualReturns(chartData) {
      const data = [];
      for (let index = 0; index < 20; index++) {
        if (chartData[index] !== undefined) data.push(this.getTwoFixedVal(chartData[index].annual_returns));
      }
      return data;
    },

    getAnnualBenchmarkReturns(chartData) {
      const data = [];
      for (let index = 0; index < 20; index++) {
        if (chartData[index] !== undefined) data.push(this.getTwoFixedVal(chartData[index].annual_benchmark_returns));
      }
      return data;
    },
    getReturnDistributionXaxis(chartData){
      const data = [];
      _.forEach(chartData, function(element, key) {
        data.push(element.index);
      });
      return data;
    },
    getReturnDistributionYaxis(chartData){
      const data = [];
      _.forEach(chartData, function(element, key) {
        data.push(element.count);
      });
      return data;
    },
    getAnnualYears(chartData) {
      const data = [];
      for (let index = 0; index < 20; index++) {
        if (chartData[index] !== undefined) data.push(chartData[index].years);
      }
      return data;
    },
    getQuarterlyData() {
      const data = [];
      for (let index = 0; index < 20; index++) {
        if (this.quarterlyReturns[index] !== undefined) {
          const obj = {
            name: this.quarterlyReturns[index].years,
            data: [
              {
                x: 'Quarter1',
                y: this.getTwoFixedValElseZero(this.quarterlyReturns[index].Quarter1),
              },
              {
                x: 'Quarter2',
                y: this.getTwoFixedValElseZero(this.quarterlyReturns[index].Quarter2),
              },
              {
                x: 'Quarter3',
                y: this.getTwoFixedValElseZero(this.quarterlyReturns[index].Quarter3),
              },
              {
                x: 'Quarter4',
                y: this.getTwoFixedValElseZero(this.quarterlyReturns[index].Quarter4),
              },
            ],
          };
          data.push(obj);
        }
      }
      return data;
    },

    isBrokerAdminDidManualImport() {
      if (localStorage.getItem('arClientCode')=='siddharth' || localStorage.getItem('arClientCode')=='aradmin') {
        return true;
      }
      else {
        return false;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/assets/js/Report/PDF.js